<template>
  <div>
    <b-modal
        scrollable
      id="supplier-deactivate"
      ref="modal"
      header-class="headerModal"
      centered
      :title="`${$t('DeactivateSupplier')}`"
      hide-footer
    >

      <p>{{ $t("YouAreD") }} {{ editOtherId.supplierName }}</p>
      <div class="buttonsEverywhere">
        <b-button
          type="button"
          variant="none"
          class="buttonSubmit"
          @click="onSubmit"
        >
          {{ $t("Deactivate") }}
        </b-button>
        <b-button
          type="reset"
          variant="danger"
          class="buttonCancel"
          style="margin-right: 15px; ; background: white; color: black; border-color: white;font-weight: 400;"
          @click="onCancel"
        >
          {{ $t('Cancel') }}
        </b-button>
      </div>
    </b-modal></div>
</template>

<script>

export default {
  props: {
    editOtherId: {
      type: Object,
    },
  },
  data() {
    return {}
  },
  methods: {
    onSubmit() {
      this.$emit('inActiveOtherSupp', this.editOtherId.supplierId)
      this.$refs.modal.hide()
    },
    onCancel() {
      this.$refs.modal.hide()
    },
  },
}

</script>

<style lang="scss" scoped>
  form {
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
  .deactivate-modal__select {
    display: flex;
    flex-direction: column;
    select {
      margin-bottom: 10px;
      padding: 10px;
    }
    button {
      align-self: end;
    }
  }
  .flex-form {
    display: flex;
    flex-direction: column;
  }
  .my-class {
  background: black;
  font-weight: bold;
}

  // .my-second-class > .modal-dialog > .modal-content > .modal-header {
  // background: black;
  // color: white;
  // }
</style>
